import { CustomCellRendererProps } from "ag-grid-react";
import { useCallback } from "react";

export interface DataTableImageProps extends CustomCellRendererProps {
  width?: number | string;
  height?: number | string;
  padding?: number | string;
  onClick?: (rowData: CustomCellRendererProps["data"]) => void;
}

export function DataTableImage({
  value,
  data: rowData,
  width = "100%",
  height = "100%",
  padding = "8px",
  onClick
}: DataTableImageProps) {
  const handleClick = useCallback(() => {
    onClick?.(rowData);
  }, [onClick, rowData]);

  const containerStyle = {
    width,
    height,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    padding
  };

  if (!value) {
    return (
      <div style={containerStyle} data-testid="image-component">
        <span style={{ opacity: 0.5 }}>No Image</span>
      </div>
    );
  }

  return (
    <div style={containerStyle} data-testid="image-component">
      <img
        src={value}
        alt=""
        onClick={handleClick}
        style={{
          maxWidth: "100%",
          maxHeight: "100%",
          objectFit: "contain",
          cursor: onClick ? "pointer" : "default"
        }}
        data-testid="image-element"
      />
    </div>
  );
}
